<template>
  <div style="background-color: #F8F9FB;text-align: center;">
    <hhead v-if="PCShow"></hhead>
    <div class="invitation">
      <img
        v-show="btn_show"
        src="../../../assets/images/crm/invitation.png"
        alt=""
      />
      <img v-show="suc" src="../../../assets/images/crm/success.png" alt="" />
      <img v-show="err" src="../../../assets/images/crm/err.png" alt="" />
      <p :style="{ fontSize: fz }">{{ msg }}</p>
      <div
        v-show="btn_show"
        :style="{ width: w, height: h, lineHeight: h, fontSize: fz }"
        class="btn"
        @click="add"
      >
        立即加入
      </div>
      <router-link v-show="i_show" class="btn" style="display: block;" to="/"
        >返回首页</router-link
      >
    </div>
  </div>
</template>
<script>
import hhead from '../header/index';
import './style.css';
export default {
  components: { hhead },
  data() {
    return {
      w: '',
      h: '',

      fz: '',
      PCShow: true,
      msg: '',
      btn_show: true,
      err: false,
      i_show: false,
      suc: false,
    };
  },
  mounted() {
    if (
      window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPad|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.PCShow = false;
      this.w = '200px';
      this.h = '55px';
      this.fz = '28px';
    } else {
      this.PCShow = true;
      this.w = '';
      this.h = '';
      this.fz = '';
    }

    if (this.$route.query.type) {
      this.$axios
        .post('/crm/mem/getInviteLinkInfo', {
          apiToken: this.$store.state.usermsg.apiToken,
          code: this.$route.query.type,
        })
        .then((res) => {
          // console.log(res)
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.msg = `尊敬的用户“${this.$store.state.usermsg.name}”您好，用户“${res.data.data.customerName}”邀请您成为“${res.data.data.entName}”管理员，赶紧加入吧。`;
          } else {
            this.err = true;
            this.msg = '当前链接已失效';
            this.i_show = true;
            this.btn_show = false;
          }
        });
    }
  },
  methods: {
    add() {
      //加入
      if (this.$route.query.type) {
        this.$axios
          .post('/crm/mem/agreeInviteLink', {
            apiToken: this.$store.state.usermsg.apiToken,
            code: this.$route.query.type,
          })
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.btn_show = false;
              this.i_show = true;
              this.suc = true;

              this.msg = '您的申请已经发送成功，正在等待合作方管理员审核!';
              if (this.PCShow) {
                this.$alert(res.data.message, {
                  confirmButtonText: '确定',
                  type: 'success',
                  center: true,
                })
                  .then(() => {
                    this.$router.push('/crm/index');
                  })
                  .catch(() => {});
              } else {
                //进入手机页面
                this.$router.push('/crm/invitation/succ');
              }
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/invitation/index.vue